import "./Footer.css"

function Footer() {
    return <>
        <footer>
            <div className="footer-links">
                <a href="mailto:padaku.game@gmail.com">Contact Me</a>
                <span className="separator">•</span>
                <a href="/privacy_policy.html">Privacy Policy</a>
                <span className="separator">•</span>
                <p>©2026 Anil G.R. All rights reserved.</p>
            </div>
        </footer>
    </>
}

export default Footer;